import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getEventAnalytics, getEventResponsesAnalytics } from './event-analytics-thunk';
const initialState = {
    status: APIStatus.IDLE,
    analytics: null,
    responses: null,
    eventId: null,
    error: undefined
};
const eventAnalyticSlice = createSlice({
    name: 'eventAnalytic',
    initialState,
    reducers: {
        setAnalytics: (state, action) => {
            state.analytics = action.payload;
        },
        setEventId: (state, action) => {
            state.eventId = action.payload;
        },
        clearAnalytics: (state) => {
            state.analytics = null;
            state.responses = null;
            state.eventId = null;
            state.error = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEventAnalytics.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(getEventAnalytics.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.analytics = action.payload;
        })
            .addCase(getEventAnalytics.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.error = action.payload;
        });
        builder.addCase(getEventResponsesAnalytics.pending, (state) => {
            state.status = APIStatus.PENDING;
        });
        builder.addCase(getEventResponsesAnalytics.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.responses = action.payload;
        });
        builder.addCase(getEventResponsesAnalytics.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.error = action.payload;
        });
    }
});
export const { setAnalytics, clearAnalytics, setEventId } = eventAnalyticSlice.actions;
export default eventAnalyticSlice.reducer;
